import React from 'react';

const LoadingSpinner = ({ size = 'md', className = '' }) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-6 h-6 border-3',
    lg: 'w-8 h-8 border-4'
  };

  return (
    <div className={`inline-block border-gray-300 border-solid rounded-full border-t-cyan-400 animate-spin ${sizeClasses[size]} ${className}`}>
      <span className="sr-only">Loading...</span>
    </div>
  );
};

const LoadingState = ({ message = 'Loading...', className = '' }) => {
  return (
    <div className={`flex items-center justify-center p-8 ${className}`}>
      <LoadingSpinner size="md" className="mr-3" />
      <span className="text-cyan-400">{message}</span>
    </div>
  );
};

export { LoadingSpinner, LoadingState };
export default LoadingState;
